// this limit does not include the "other" slice
export const FIELD_LIMIT = 7;

export const SingleSelectChart = {
	HORIZONTAL_BAR: 'horizontalBar',
	DONUT: 'donut',
} as const;

export type SingleSelectChartType = (typeof SingleSelectChart)[keyof typeof SingleSelectChart];

export const DEFAULT_CHART_TYPE = SingleSelectChart.DONUT;

export const SingleSelectChartList: SingleSelectChartType[] = Object.values(SingleSelectChart);
